export default __webpack_public_path__ + "static/media/spa-banner-06.ae915a63.jpg";